import React from "react";
import hero from "../../assets/home/hero/hero.webp";
import herohand from "../../assets/home/hero/herohand.png";
import heart from "../../assets/home/hero/heart.png";

const HeroSection = () => {
  return (
    <div className="flex flex-col lg:flex-row w-full overflow-hidden">
      {/* Mobile: Image on top (hidden on desktop) */}
      <div className="lg:hidden h-[50vh] w-full">
        <img
          src={hero}
          alt="heroimage"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Left side - Purple content area */}
      <div className="lg:w-1/2 bg-gradient-to-t from-purple-800 to-purple-700 flex flex-col justify-between h-[60vh] lg:h-[83vh] p-6 lg:p-12 relative">
        {/* Mobile: Hand watermark background (hidden on desktop) */}
        <div className="lg:hidden absolute inset-0 flex items-center justify-center opacity-20">
          <img
            src={herohand}
            alt="hands watermark"
            className="h-[90%] w-auto object-contain"
          />
        </div>

        {/* Desktop: Heart background decoration (hidden on mobile) */}
        <div className="hidden lg:block absolute opacity-30 right-0 top-0">
          <img src={heart} alt="heart" className="w-[20rem]" />
        </div>

        {/* Text content */}
        <div className="flex flex-col gap-4 z-10">
          <h1 className="text-white text-3xl lg:text-4xl font-bold">
            Welcome To <span className="ml-2">SilverTLC</span>
          </h1>
          <p className="text-gray-100 text-lg lg:text-2xl max-w-[35rem]">
            The broad test of government is how that government trusts those who
            are in the dawn of life, the children; those who are in the twilight
            of life, the elderly; and those who are in the shadows of life, the
            sick, the needy and the helpless.
          </p>
          <p className="text-white font-bold">Hubert Humphreys</p>
        </div>

        {/* Desktop: Hand image at bottom (hidden on mobile) */}
        <div className="hidden lg:flex justify-center lg:justify-start relative left-[-3rem] mt-4 lg:mt-0">
          <img
            src={herohand}
            alt="hands"
            className="h-auto max-h-[50vh] w-auto object-contain"
          />
        </div>
      </div>

      {/* Right side - Hero image (hidden on mobile, shown on desktop) */}
      <div className="hidden lg:block lg:w-1/2 h-[83vh]">
        <img
          src={hero}
          alt="heroimage"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </div>
  );
};

export default HeroSection;
